// Reference data for property quick-pick fields (Turkish).

export const PROPERTY_TYPES = ["Daire", "Villa", "Arsa", "İşyeri", "Dükkân", "Ofis", "Bina", "Diğer"];
export const ROOM_COUNTS = ["Stüdyo", "1+1", "2+1", "3+1", "4+1", "5+1", "Diğer"];
export const STATUS_LIST = [
  "Yeni Eklendi", "İncelenecek", "Emlakçı Aranacak", "Randevu Planlandı",
  "Gezilecek", "Gezildi", "Teklif Verildi", "Pazarlıkta", "Beklemede",
  "Elendi", "Satın Alındı", "Satışa Hazırlanıyor", "Satışta", "Satıldı",
];
export const USAGE_LIST = [
  "Boş", "Ev sahibi oturuyor", "Kiracı oturuyor",
  "İnşaat halinde", "Yeni teslim", "Bilinmiyor",
];
export const FURNISHING_LIST = ["Eşyalı", "Kısmi eşyalı", "Eşyasız", "Bilinmiyor"];
export const ORIENTATION_LIST = [
  "Kuzey", "Güney", "Doğu", "Batı",
  "Kuzeydoğu", "Kuzeybatı", "Güneydoğu", "Güneybatı",
  "Birden fazla cephe", "Bilinmiyor",
];
export const HEATING_LIST = [
  "Doğalgaz kombi", "Merkezi sistem", "Klima", "Elektrikli",
  "Yerden ısıtma", "Isıtma yok", "Bilinmiyor",
];
export const PARKING_LIST = [
  "Yok", "Açık otopark", "Kapalı otopark", "Açık ve kapalı",
  "Daireye tahsisli", "Sokak parkı", "Bilinmiyor",
];
export const DEED_LIST = [
  "Kat mülkiyeti", "Kat irtifakı", "Arsa tapusu", "Hisseli tapu", "Bilinmiyor",
];
export const CONDITION_LIST = [
  "Çok iyi", "İyi", "Orta", "Tadilat gerekli", "Ağır tadilat gerekli", "Bilinmiyor",
];

export const FEATURES_POSITIVE = [
  { key: "has_pool", label: "Havuz var" },
  { key: "has_elevator", label: "Asansör var" },
  { key: "has_balcony", label: "Balkon var" },
  { key: "has_natural_gas", label: "Doğalgaz var" },
  { key: "has_ac", label: "Klima var" },
  { key: "open_to_negotiation", label: "Pazarlığa açık" },
  { key: "urgent_sale", label: "Acil satış ihtimali" },
];

export const FEATURES_NEGATIVE = [
  { key: "humidity", label: "Rutubet" },
  { key: "noise", label: "Gürültü" },
  { key: "dark", label: "Daire karanlık" },
  { key: "facade_issue", label: "Dış cephe sorunu" },
  { key: "roof_risk", label: "Çatı riski" },
  { key: "parking_insufficient", label: "Otopark yetersiz" },
  { key: "bathroom_vent", label: "Banyo havalandırma" },
  { key: "common_area_neglect", label: "Ortak alanlar bakımsız" },
];

export const PHOTO_CATEGORIES = [
  "Salon", "Mutfak", "Oda", "Banyo", "Balkon", "Manzara",
  "Bina dışı", "Ortak alan", "Havuz", "Otopark", "Teknik sorun", "Belge", "Diğer",
];

export const PERSON_TYPES = [
  "emlakçı", "ev sahibi", "kiracı", "müteahhit", "site yönetimi", "diğer",
];

export const MEETING_TYPES = ["yüz yüze", "telefon", "WhatsApp", "e-posta"];

export const CATEGORY_COLORS = {
  Gezdiklerim: "#10B981",
  Gezeceklerim: "#3B82F6",
  "Sahip Olduklarım": "#F59E0B",
};

export const STATUS_TO_CATEGORY = {
  "Gezildi": "Gezdiklerim",
  "Teklif Verildi": "Gezdiklerim",
  "Pazarlıkta": "Gezdiklerim",
  "Randevu Planlandı": "Gezeceklerim",
  "Gezilecek": "Gezeceklerim",
  "Emlakçı Aranacak": "Gezeceklerim",
  "İncelenecek": "Gezeceklerim",
  "Yeni Eklendi": "Gezeceklerim",
  "Satın Alındı": "Sahip Olduklarım",
  "Satışa Hazırlanıyor": "Sahip Olduklarım",
  "Satışta": "Sahip Olduklarım",
  "Satıldı": "Sahip Olduklarım",
};
